import React from "react";
import { Link, withRouter } from "react-router-dom";

const Navbar = () => {
  return (
    <div className="main-header-area navbar-area header-sticky">
      <div className="container">
        <div className="classy-nav-container breakpoint-off">
          <nav
            className="classy-navbar justify-content-between"
            id="Sarkarizone"
          >
            <Link to="/">
              <img src="logo.png" alt="logo" />
            </Link>
            <div className="classy-navbar-toggler">
              <span className="navbarToggler">
                <span></span>
                <span></span>
                <span></span>
              </span>
            </div>
            <div className="classy-menu">
              <div className="classycloseIcon">
                <div className="cross-wrap">
                  <span className="top"></span>
                  <span className="bottom"></span>
                </div>
              </div>
              <div className="classynav">
                <ul>
                  <li>
                    <Link to="/">
                      <i className="icofont-home pr-2 icons">
                        <span className="icons">Home</span>
                      </i>{" "}
                    </Link>
                  </li>
                  <li>
                    <Link to="/about-us">
                      <i className="icofont-info-circle pr-2 icons">
                        <span>About</span>
                      </i>{" "}
                    </Link>
                  </li>
                  <li>
                    <Link to="/our-facilities">
                      <i className="icofont-server pr-2 icons">
                        <span>Our Facilities</span>
                      </i>{" "}
                    </Link>
                  </li>
                  <li>
                    <Link to="/gallery">
                      <i className="icofont-image pr-2 icons">
                        <span>Gallery</span>
                      </i>{" "}
                    </Link>
                  </li>

                  <li>
                    <Link to="/contact-us">
                      <i className="icofont-ui-call pr-2 icons">
                        <span>Contact</span>
                      </i>
                    </Link>
                  </li>
                  <li></li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Navbar);
